
export enum Roles {
    superAdmin = 'Super Admin',
    owner = 'Owner',
    orgAdmin = 'Organzition Admin',
    orgFinance = 'Organization Finance',
    orgCompliance = 'Organization Compliance',
    orgResources = 'Organization Resouces',
    orgSuppliers = 'Organization Suppliers',
    orgViewers = 'Organization Viewer',
    client = 'Client',
    depositor = 'Depositor',
    supplier = "Supplier"
}
